// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__j5oo3","active":"styles_active__qw7Re","modal_content":"styles_modal_content__1Md+T","modal_actions":"styles_modal_actions__4yz-v","btn":"styles_btn__FvT7f"};